import { Button, Grid } from "@material-ui/core";
import CheckCircleOutlineOutlinedIcon from "@material-ui/icons/CheckCircleOutlineOutlined";

const SuccessPage = ({ msg, projectId }) => {
  return (
    <Grid
      item
      xs={12}
      style={{
        minHeight: "calc(100vh - 133px)",
        display: "flex",
        justifyContent: "center",
        flexDirection: "column",
        alignItems: "center",
        height: "100%"
      }}
    >
      <CheckCircleOutlineOutlinedIcon
        style={{ color: "#5ACA49", fontSize: "64px" }}
      ></CheckCircleOutlineOutlinedIcon>
      <h2 className="mt-2">Success!</h2>
      <h4 className="mt-2">{msg}</h4>
      <div style={{display: "flex"}}>
       <Button
          autoFocus
          className="mt-5"
          style={{
            color: "white",
            backgroundColor: "#1176B5",
            borderRadius: "4px",
            boxShadow: "0 0.4px 0.6px 0 rgba(0,0,0,0.37), 0 0.1px 0 0.4px #0A649D",
            height: "40px",
            minWidth: "200px",
            textTransform: "capitalize"
          }}
          onClick={() => {
            window.location.href = `/project/${projectId}`;
          }}
        >
          Return to Project Page
        </Button>
      </div>
    </Grid>
  );
};

export default SuccessPage;
